import { render, staticRenderFns } from "./gridPrincipalItem.vue?vue&type=template&id=07bf0edc&"
import script from "./gridPrincipalItem.vue?vue&type=script&lang=js&"
export * from "./gridPrincipalItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports